module.exports = __webpack_public_path__ + "static/media/glansgarant.c8aff5a2.png";